"use strict";

var curry = require("./curry.js");

var entriesL = require("../Lazy/entriesL.js");

var mapEntriesL = require("../Lazy/mapEntriesL.js");

var object = require("./object.js");

module.exports = curry(function mapObject(f, obj) {
  return object(mapEntriesL(f, entriesL(obj)));
});